import React from 'react';
import { chooseIconIndex } from 'utils/helperMethods';
const iconIndex = chooseIconIndex();
const CompareIcon = ({ stroke }: { stroke: string }) => {
    //2K
    if (iconIndex === 1) {
        return (
            <svg width="13" height="14" viewBox="0 0 13 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M1.33337 10.6667H12M12 10.6667L9.33337 8.00004M12 10.6667L9.33337 13.3334M12 4.00004H1.33337M1.33337 4.00004L4.00004 1.33337M1.33337 4.00004L4.00004 6.66671"
                    stroke={stroke}
                    stroke-width="1.33333"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        );
    }
    //4K
    if (iconIndex === 2) {
        return (
            <svg width="18" height="20" viewBox="0 0 18 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M1 14.9999H17M17 14.9999L13 10.9999M17 14.9999L13 18.9999M17 4.99994H1M1 4.99994L5 0.999939M1 4.99994L5 8.99994"
                    stroke={stroke}
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        );
    }
    //BELOW 2K
    return (
        <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M1 7.5H9M9 7.5L7 5.5M9 7.5L7 9.5M9 2.5H1M1 2.5L3 0.5M1 2.5L3 4.5"
                stroke={stroke}
                stroke-linecap="round"
                stroke-linejoin="round"
            />
        </svg>
    );
};

export default CompareIcon;
